import dayjs from "dayjs";
import "dayjs/locale/ar-sa";
import "dayjs/locale/en";

import store from "../store";

export const renderFormatedDate = (date, format = "DD/MM/YYYY") => {
  const lang = store.getState().locale.lang;
  dayjs.locale( lang === "ar" ? "ar-sa" : "en");

  if (date) return dayjs(date).format(format);
};

export const getYearMonthFromDate = (date) => {
  // ex: August, 2025
  if (!date) return null;
  const lang = store.getState().locale.lang;
  dayjs.locale( lang === "ar" ? "ar-sa" : "en");
  return dayjs(date).format("MMMM, YYYY"); // Returns month name in current locale
};

export const checkIfTotimeIsAfterFromtime = (toTime, fromTime) => {
  const to = dayjs(toTime, 'HH:mm:ss');
  const from = dayjs(fromTime, 'HH:mm:ss');
  return to.isAfter(from) 
};
